export default __webpack_public_path__ + "2e3d794b5b16ae582b73737a023713a8.woff";